import { render, staticRenderFns } from "./VolunteerWelcomeModal.vue?vue&type=template&id=951785d0&"
import script from "./VolunteerWelcomeModal.vue?vue&type=script&lang=js&"
export * from "./VolunteerWelcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./VolunteerWelcomeModal.vue?vue&type=style&index=0&id=951785d0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports